import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { selectRequestCode } from '../store/slice'

const TopComponent = ({ dataFilter }) => {
  const dispatch = useDispatch()
  const requestCode = useSelector(selectRequestCode)

  // useEffect(() => {
  //   const fetchDetail = async () => {
  //     if (requestCode) {
  //       const [prefix, id] = requestCode.split('-')
  //       try {
  //         let res
  //         if (prefix === 'P') {
  //           res = await ConnectMapService.getPersonDetail({ PersonId: id })
  //           dispatch(changeValueSearchPerson(res?.data))
  //         } else if (prefix === 'O') {
  //           res = await ConnectMapService.getCompanyDetail({
  //             OrganizationId: id,
  //           })
  //           dispatch(changeValueSearchCompany(res.data))
  //         }
  //       } catch (error) {}
  //       return
  //     }
  //   }

  //   fetchDetail()
  // }, [requestCode])

  return (
    <Element
      style={{
        color: '#0553A5',
        fontSize: 24,
        padding: '12px 0',
      }}
    >
      {dataFilter?.searchCompany?.organizationName ||
        dataFilter?.searchPerson?.fullName ||
        ''}
    </Element>
  )
}

export default TopComponent
